import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

export const FadePanel = ({ fadeKey, children }: { fadeKey: string; children: ReactNode }) => (
  <AnimatePresence mode="wait" initial={false}>
    <motion.div
      key={fadeKey}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeInOut' }}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {children}
    </motion.div>
  </AnimatePresence>
);
